<template>
  <section class="products-section">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header">
        <div class="title-wrapper">
          <div class="decor-line left">
            <span class="dot"></span>
          </div>
          <h2 class="section-title">产品与服务</h2>
          <div class="decor-line right">
            <span class="dot"></span>
          </div>
        </div>
        <div class="title-underline"></div>
      </div>

      <!-- Products Grid -->
      <div class="products-grid">
        <!-- Card 1 -->
        <div class="product-card clickable-card" @click="openLink('https://ioa.cloud.tencent.com/')">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/1.png" alt="腾讯安全 iOA" @error="handleImageError" />
          </div>
          <h3 class="product-title">腾讯安全 iOA</h3>
          <p class="product-desc">基于零信任安全架构，为企业提供终端安全防护与统一访问控制解决方案。</p>
        </div>

        <!-- Card 4 (Moved to 2nd position) -->
        <div class="product-card clickable-card" @click="openLink('https://cloud.tencent.com/')">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/4.png" alt="腾讯云与云产品服务" @error="handleImageError" />
          </div>
          <h3 class="product-title">腾讯云与云<br>产品服务</h3>
          <p class="product-desc">提供稳定、安全的云计算、大数据、人工智能等全栈云服务能力。</p>
        </div>

        <!-- Card 6 (Moved to 3rd position) -->
        <div class="product-card clickable-card" @click="openLink('https://www.codebuddy.cn/home/')">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/6.png" alt="AI办公与辅助开发" @error="handleImageError" />
          </div>
          <h3 class="product-title">AI办公与辅助开发</h3>
          <p class="product-desc">提供WorkBuddy、CodeBuddy等智能办公与开发工具，全方位提升企业效率。</p>
        </div>

        <!-- Card 3 (Moved to 4th position) -->
        <div class="product-card clickable-card" @click="openLink('https://meeting.tencent.com/')">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/3.png" alt="腾讯会议" @error="handleImageError" />
          </div>
          <h3 class="product-title">腾讯会议</h3>
          <p class="product-desc">提供高清流畅、便捷易用、安全可靠的云视频会议服务，助力企业高效协作。</p>
        </div>

        <!-- Card 2 -->
        <div class="product-card">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/2.png" alt="企业微信行业解决方案" @error="handleImageError" />
          </div>
          <h3 class="product-title">企业微信行业<br>解决方案</h3>
          <p class="product-desc">覆盖多行业场景，提供定制化解决方案，助力企业数字化转型。</p>
        </div>

        <!-- Card 5 (Moved to 6th/last position) -->
        <div class="product-card">
          <div class="icon-wrapper">
            <img src="../assets/ProductsSection/5.png" alt="微信生态产品与定制开发" @error="handleImageError" />
          </div>
          <h3 class="product-title">微信生态产品与<br>定制开发</h3>
          <p class="product-desc">小程序、公众号、企业微信微商城等生态产品，定制开发，助力业务创新。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductsSection',
  methods: {
    handleImageError(e) {
      // 占位处理：如果图片路径不对，显示一个灰色的默认方块
      e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="%23f0f0f0"><rect width="100" height="100" rx="10"/></svg>';
    },
    openLink(url) {
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.products-section {
  padding: 80px 0 100px;
  background-color: #f7f9fc;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 40px);
}

/* Header Styles */
.section-header {
  text-align: center;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 12px;
}

.section-title {
  font-size: clamp(24px, 3vw, 36px);
  color: #111;
  font-weight: 800;
  margin: 0 20px;
  letter-spacing: 1px;
}

.decor-line {
  display: flex;
  align-items: center;
  width: 80px;
}

.decor-line.left {
  justify-content: flex-end;
  background: linear-gradient(to left, rgba(0, 82, 217, 0.4), transparent);
  height: 1px;
  position: relative;
}

.decor-line.left .dot {
  position: absolute;
  right: -6px;
  width: 6px;
  height: 6px;
  background-color: #0052d9;
  border-radius: 50%;
}

.decor-line.right {
  justify-content: flex-start;
  background: linear-gradient(to right, rgba(0, 82, 217, 0.4), transparent);
  height: 1px;
  position: relative;
}

.decor-line.right .dot {
  position: absolute;
  left: -6px;
  width: 6px;
  height: 6px;
  background-color: #0052d9;
  border-radius: 50%;
}

.title-underline {
  width: 48px;
  height: 4px;
  background-color: #0052d9;
  border-radius: 2px;
  margin-top: 8px;
}

/* Grid Styles */
.products-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
}

/* Card Styles */
.product-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  height: 100%;
  position: relative;
  overflow: hidden;
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 82, 217, 0.04), transparent);
  transition: left 0.6s ease;
  pointer-events: none;
}

.product-card:hover::before {
  left: 100%;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 82, 217, 0.1);
  border-color: rgba(0, 82, 217, 0.1);
}

.clickable-card {
  cursor: pointer;
}

.icon-wrapper {
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-title {
  font-size: 18px;
  color: #111;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.4;
  height: 50px; /* 给固定高度应对有折行的标题 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-desc {
  font-size: 14px;
  color: #666;
  font-weight: 500; /* 加粗一点 */
  line-height: 1.8;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 1400px) {
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 40px;
  }
}

@media (max-width: 900px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .product-title {
    height: auto;
  }
}

@media (max-width: 600px) {
  .products-section {
    padding: 48px 0 48px;
  }
  .products-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .section-header {
    margin-bottom: 32px;
  }
  .product-card {
    padding: 28px 20px;
  }
  .icon-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }
  .product-title {
    font-size: 16px;
    margin-bottom: 12px;
  }
  .product-desc {
    font-size: 13px;
  }
  .decor-line {
    width: 40px;
  }
}
</style>
